<script>
    import { imageStore, editStore } from '../stores';
    import { constructUrl } from '../utils/apiClient';
    import { t } from '../i18n';


    let fileInput;
    let dragActive = false;
    let errorMessage = '';
    let selectionVersion = 0;
  
    
  
    function handleDrop(event) {
      event.preventDefault();
      dragActive = false;
      if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
        const file = event.dataTransfer.files[0];
        validateAndUploadFile(file);
      }
    }

    let isUploading = false;

    function handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        validateAndUploadFile(file);
      }
      // 같은 파일을 다시 선택해도 change 이벤트가 발생하도록 입력값 초기화
      event.target.value = '';
    }

    async function validateAndUploadFile(file) {
      console.log("validateAndUploadFile 실행");

      // 이미지 정보 로그
      console.log("파일 이름:", file.name);
      console.log("파일 유형:", file.type);
      console.log("파일 크기:", file.size, "bytes");

      // 파일 유형 검증
      if (!file.type.match('image.*')) {
        errorMessage = '이미지 파일만 업로드할 수 있습니다.';
        return;
      }
    
      // 파일 크기 검증 (10MB 제한)
      if (file.size > 10 * 1024 * 1024) {
        errorMessage = '파일 크기는 10MB 이하여야 합니다.';
        return;
      }

      errorMessage = '';
      const currentVersion = ++selectionVersion;

      imageStore.update(store => ({ ...store, resultImage: null, resultImages: null, serverImageUrl: null,
        currentTaskImageUrl: null, taskOriginalImageUrl: null, resultOptions: null, resultFeature: null }));
      editStore.update(store => ({ ...store, currentTaskId: null, editHistory: [], currentEditIndex: -1 }));
      // 파일 미리보기용 URL 생성 (즉시 표시를 위해 FileReader 사용)
      const reader = new FileReader();
      reader.onload = function (e) {
        if (currentVersion !== selectionVersion) return;
        console.log("이미지 미리보기 URL:", e.target.result);
        
        // 이미지 크기 계산을 위한 임시 이미지 객체
        const img = new Image();
        img.onload = function() {
          if (currentVersion !== selectionVersion) return;
          console.log('이미지 크기 계산 성공:', img.width, 'x', img.height);
          
          // Store 업데이트 (FileReader 결과로 즉시 표시)
          imageStore.update(store => ({
            ...store,
            uploadedImageUrl: e.target.result,
            uploadedImage: file,
            imageWidth: img.width,
            imageHeight: img.height
          }));
          
          console.log('미리보기 업데이트 완료');
        };
        
        img.onerror = function() {
          if (currentVersion !== selectionVersion) return;
          console.warn('이미지 크기 계산 실패, 기본값 사용');
          
          // 크기 계산 실패해도 미리보기는 표시
          imageStore.update(store => ({
            ...store,
            uploadedImageUrl: e.target.result,
            uploadedImage: file,
            imageWidth: 800, // 기본값
            imageHeight: 600 // 기본값
          }));
          
          console.log('미리보기 업데이트 완료 (기본 크기)');
        };
        
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  
    function handleDragOver(event) { event.preventDefault(); dragActive = true; }
    function handleDragLeave() { dragActive = false; }
    let lastDialogOpen = 0;
    function openFileDialog() {
      const now = Date.now();
      if (now - lastDialogOpen < 500 || !fileInput) return;
      lastDialogOpen = now; fileInput.value = ''; fileInput.click();
    }
  </script>
  
  <div class="upload-section">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="upload-container"
         class:drag-active={dragActive}
         class:has-image={$imageStore.uploadedImageUrl}
         on:dragover={handleDragOver}
         on:dragleave={handleDragLeave}
         on:drop={handleDrop}
         on:click={() => !$imageStore.uploadedImageUrl && openFileDialog()}>
      
      {#if $imageStore.uploadedImageUrl}
        <div class="preview-container">
          <img 
            src={constructUrl($imageStore.uploadedImageUrl)} 
            alt="업로드된 이미지" 
            class="preview-image" 
            on:load={() => console.log("미리보기 이미지 로드됨")}
            on:error={(e) => console.error("미리보기 이미지 로드 오류:", e, "Url:", constructUrl($imageStore.uploadedImageUrl))}
          />
          <div class="image-info">
            <p>{$t('resolution')}: {$imageStore.imageWidth} x {$imageStore.imageHeight}</p>
          </div>
          <div class="button-group">
            <button class="change-image-btn" on:click={openFileDialog}>{$t('changeImage')}</button>
            <!-- <button class="go-edit-btn" on:click={goToEditTab}>편집으로 이동</button> -->
          </div>
        </div>
      {:else}
        <div class="upload-prompt" 
             on:click={openFileDialog}
             on:keydown={(e) => e.key === 'Enter' && openFileDialog()}
             tabindex="0"
             role="button"
             aria-label={$t('feature.upload_image')}>
          <div class="upload-icon">📷</div>
          <h3>{$t('feature.upload_image')}</h3>
          <p>{$t('uploadInstruction')}</p>
          <p class="file-types">{$t('maxFile')}</p>
        </div>
      {/if}
      
      <input 
        type="file" 
        bind:this={fileInput}
        on:change={handleFileSelect}
        accept="image/*" 
        style="display: none;" 
      />
    </div>
    
    {#if errorMessage}
      <div class="error-message">
        {errorMessage}
      </div>
    {/if}
    
  </div>
  
  <style>
    .upload-section {
      display: flex;
      flex-direction: column;
      gap: 2rem;
      max-width: 1600px;
      margin: 0 auto;
    }
  
    .upload-container {
      border: 2px dashed rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      padding: 10rem;
      padding-left: 27rem;
      padding-right: 27rem;
      margin-top: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    @media (max-width: 768px) {
      .upload-container {
        padding: 2rem;
        padding-left: 2rem;
        padding-right: 2rem;
      }
    }

    @media (max-width: 480px) {
      .upload-container {
        padding: 1rem;
      }
    }

    .upload-container.has-image {
      padding: 2rem;
    }

    :global(.light) .upload-container {
      border-color: rgba(0, 0, 0, 0.2);
    }
  
    .upload-container:hover {
      border-color: #FF6382;
    }
  
    .drag-active {
      border-color: #FF6382;
      background-color: rgba(255, 99, 130, 0.05);
    }

    :global(.light) .drag-active {
      background-color: rgba(255, 99, 130, 0.1);
    }
  
    .upload-prompt {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  
    .upload-icon {
      font-size: 3rem;
      margin-bottom: 1rem;
    }
  
    h3 {
      margin: 0 0 1rem 0;
      font-size: 1.5rem;
    }
  
    p {
      margin: 0 0 0.5rem 0;
      font-size: 1rem;
    }
  
    .file-types {
      font-size: 0.8rem;
      opacity: 0.7;
    }
  
    .preview-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
  
    .preview-image {
      max-width: 100%;
      max-height: 400px;
      border-radius: 8px;
      margin-bottom: 1rem;
    }
  
    .image-info {
      margin-bottom: 1rem;
      font-size: 0.9rem;
      color: white;
    }

    :global(.light) .image-info {
      color: black;
    }
  
    .button-group {
      display: flex;
      gap: 1rem;
    }
  
    .change-image-btn {
      padding: 0.8rem 1.5rem;
      border-radius: 8px;
      border: none;
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .change-image-btn {
      background: linear-gradient(90deg, #FF9A3E, #FF6A00);
      color: white;
    }

    .change-image-btn:hover {
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }
  
    .error-message {
      color: #FF6382;
      text-align: center;
      padding: 1rem;
      background-color: rgba(255, 99, 130, 0.1);
      border-radius: 8px;
    }

    @media (max-width: 800px) { .upload-container { margin: 16px; padding: 24px; } }
  </style>
